const observeAttribute = (
  element: HTMLElement,
  attributeNames: string[],
  callback: (newValue: string | null) => void
): MutationObserver => {
  const observer = new MutationObserver(mutationsList => {
    if (
      mutationsList.some(
        mutation => mutation.type === 'attributes' && attributeNames.includes(mutation.attributeName ?? '')
      )
    ) {
      const newValue = attributeNames.reduce<string | null>(
        (acc, attrName) => acc ?? element.getAttribute(attrName),
        null
      );
      callback(newValue);
      observer.disconnect();
    }
  });

  observer.observe(element, { attributes: true });

  return observer;
};

export default observeAttribute;
